'use client';

import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from 'react';
import { AnimatedNumber } from '@/components/ui/animated-number';
const PROGRESS_SCALE: number = 10_000;
const PROGRESS_SCALE_BIGINT: bigint = BigInt(PROGRESS_SCALE);
interface AnimatedBigIntOnMountProps {
  readonly value: bigint;
  readonly format: (value: bigint) => ReactNode;
  readonly duration?: number | undefined;
  readonly className?: string | undefined;
}

/**
 * Reuses AnimatedNumber's mount tween and reduced-motion behavior while
 * keeping fixed-point values in bigint throughout every rendered frame.
 */
export function AnimatedBigIntOnMount(t0) {
  const $ = _c(11);
  const {
    value,
    format,
    duration,
    className
  } = t0;
  let t1;
  if ($[0] !== format || $[1] !== value) {
    t1 = function formatProgress(progress) {
      const scaledProgress = BigInt(Math.round(progress * PROGRESS_SCALE));
      return format(value * scaledProgress / PROGRESS_SCALE_BIGINT);
    };
    $[0] = format;
    $[1] = value;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const formatProgress = t1;
  let t2;
  if ($[3] !== duration) {
    t2 = duration !== undefined ? {
      duration
    } : {};
    $[3] = duration;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== className) {
    t3 = className !== undefined ? {
      className
    } : {};
    $[5] = className;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== formatProgress || $[8] !== t2 || $[9] !== t3) {
    t4 = <AnimatedNumber value={1} format={formatProgress} animateOnMount={true} {...t2} {...t3} />;
    $[7] = formatProgress;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
}